import { axiosInstanceV1 } from "@rentablo/api";
import {
  CreateSubscriptionParams,
  GetSubscriptionsParams,
  PageableSubscriptionList,
  Subscription,
  UpdateSubscriptionParams,
} from "../model";

export const getSubscriptions = async (
  token: string | undefined,
  params: GetSubscriptionsParams
) => {
  const { data } = await axiosInstanceV1.get<PageableSubscriptionList>(
    "/subscriptions",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    }
  );

  return data;
};

export const downloadSubscription = async (
  token: string | undefined,
  id: number
) => {
  const { data } = await axiosInstanceV1.get<File>(
    `/subscriptions/${id}?format=pdf`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    }
  );
  return data;
};

export const createSubscription = async (
  token: string | undefined,
  attrs: CreateSubscriptionParams
) => {
  const { data } = await axiosInstanceV1.post<Subscription>(
    `/subscriptions`,
    attrs,
    {
      // important: this was not forgotten, but required for affiliate tracking
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const updateSubscription = async (
  token: string | undefined,
  { id, ...attrs }: UpdateSubscriptionParams
) => {
  const { data } = await axiosInstanceV1.put<Subscription>(
    `/subscriptions/${id}`,
    attrs,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return data;
};

export const loadSubscription = async (
  token: string | undefined,
  subscriptionId?: number
) => {
  if (!subscriptionId) return;
  const { data } = await axiosInstanceV1.get<Subscription>(
    `/subscriptions/${subscriptionId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const loadMyLastIncompleteSubscription = async (
  token: string | undefined
) => {
  const { data } = await axiosInstanceV1.get<{ subscriptions: Subscription[] }>(
    `/subscriptions`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        status: "incomplete",
        isCancelled: false,
        order: "creationTimestamp DESC",
      },
    }
  );
  return data.subscriptions[0];
};
